export default __webpack_public_path__ + "static/media/discover.0cafcb56.svg";